(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/device-services.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/device-services.js');

'use strict';

function isNativeBridge() {
  return svs.tur.device.nativeBridge.isSupported();
}
class DeviceServicesFactory {
  constructor() {
    this._haptics = null;
    this._orientation = null;
  }
  get haptics() {
    if (!this._haptics) {
      this._haptics = isNativeBridge() ? new svs.tur.device.NativeHapticService() : new svs.tur.device.WebHapticService();
    }
    return this._haptics;
  }
  get orientation() {
    if (!this._orientation) {
      this._orientation = isNativeBridge() ? new svs.tur.device.NativeOrientationService() : new svs.tur.device.WebOrientationService();
    }
    return this._orientation;
  }



  get isNative() {
    return isNativeBridge();
  }
}
setGlobal('svs.tur.device.services', new DeviceServicesFactory());

 })(window);